import { styled, Card as MuiCard } from "@mui/material";

export const Card = styled(MuiCard)(()=>({
    borderRadius: '1rem',
    boxShadow: '0px .125rem .5rem 0 rgba(48, 52, 54, 0.08)',
    padding: '.75rem 1.5rem 1.25rem 1.5rem',
    paddingBottom: '1.25rem'
}))